import { use } from 'i18next';
import { initReactI18next } from 'react-i18next';
import { resources } from 'locales/resources';
import { defaultLanguage, en, fr, defaultNamespace } from 'locales/config';

// Faux positif : `use` est la methode i18next, pas le hook React
// eslint-disable-next-line react-hooks/rules-of-hooks
use(initReactI18next).init({
  lng: defaultLanguage,
  fallbackLng: fr,
  ns: defaultNamespace,
  defaultNS: defaultNamespace,
  resources,
  supportedLngs: [fr, en],
});
